{
  "DATA_ASSISTANT": {
    "TITLE": "Duomenų asistentas",
    "NEW_CONVERSATION": "+ Naujas",
    "LOADING": "Įkeliama...",
    "LOADING_MESSAGES": "Įkeliami pranešimai...",
    "THINKING": "Mąstoma...",
    "UNTITLED": "Pokalbis be pavadinimo",
    "NO_CONVERSATIONS": "Pokalbių dar nėra. Spustelėkite „+ Naujas“, kad pradėtumėte.",
    "EMPTY_STATE": "Pasirinkite pokalbį arba sukurkite naują, kad pradėtumėte.",
    "PLACEHOLDER": "Ką galiu jums sužinoti?",
    "SHOW_SQL": "Rodyti SQL",
    "NO_ROWS": "Eilučių negrąžinta.",
    "DELETE": "×",
    "DELETE_CONFIRM": "Ištrinti pokalbį",
    "DELETE_CONFIRM_DESCRIPTION": "Ar tikrai norite ištrinti šį pokalbį? Šio veiksmo anuliuoti negalima.",
    "DELETE_CONFIRM_YES": "Ištrinti",
    "REPORTS": "Ataskaitos",
    "SAVE_TO_REPORT": "Išsaugoti ataskaitoje",
    "NEW_REPORT": "Nauja ataskaita",
    "REPORT_NAME": "Ataskaitos pavadinimas",
    "NO_REPORTS": "Išsaugotų ataskaitų dar nėra",
    "REPORTS_EMPTY_STATE": "Pasirinkite ataskaitą arba sukurkite naują.",
    "REPORT_SAVED": "Išsaugota ataskaitoje",
    "DELETE_REPORT_CONFIRM": "Ištrinti ataskaitą",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Ar tikrai norite ištrinti šią ataskaitą? Visi išsaugoti elementai bus pašalinti.",
    "DELETE_ITEM_CONFIRM": "Pašalinti elementą",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Ar tikrai norite pašalinti šį elementą iš ataskaitos?",
    "EXPORT_CSV": "Eksportuoti CSV",
    "REFRESH": "Atnaujinti",
    "QUERY_RUNNING": "Vykdoma užklausa...",
    "QUERY_FAILED": "Užklausa nepavyko",
    "AUTO_REFRESH": "Automatinis atnaujinimas",
    "AUTO_REFRESH_NONE": "Rankiniu būdu",
    "AUTO_REFRESH_30S": "30 sekundžių",
    "AUTO_REFRESH_1M": "1 minutė",
    "AUTO_REFRESH_5M": "5 minutės",
    "AUTO_REFRESH_10M": "10 minučių",
    "EDIT_MESSAGE": "Redaguoti pranešimą",
    "RENAME_REPORT": "Pervadinti ataskaitą",
    "RENAME_ITEM": "Pervadinti elementą",
    "MOVE_UP": "Perkelti aukštyn",
    "MOVE_DOWN": "Perkelti žemyn",
    "COLLABORATORS": {
      "BUTTON": "Bendradarbiai",
      "TITLE": "Ataskaitos bendradarbiai",
      "DESCRIPTION": "Pasirinkite, kurie agentai ir komandos gali matyti šią ataskaitą.",
      "AGENTS": "Agentai",
      "TEAMS": "Komandos",
      "SELECT_AGENTS": "Pasirinkti agentus",
      "SELECT_TEAMS": "Pasirinkti komandas",
      "SAVE": "Išsaugoti",
      "SAVED": "Bendradarbiai atnaujinti",
      "SAVE_FAILED": "Nepavyko atnaujinti bendradarbių"
    }
  }
}
